//import { combineReducers } from "redux";

import general from "./general/reducer";
import user from "./users/reducer";
import loading from "./loading/reducer";
import quiz from "./quiz/reducer";
import teams from "./teams/reducer";

// export default combineReducers({
//   general,
//   user,
//   quiz,
//   loading,
//   teams,
// });

//eslint-disable-next-line
export default (state = {}, action) => {
  return {
    general: general(state.general, action, state),
    user: user(state.user, action, state),
    quiz: quiz(state.quiz, action, state),
    loading: loading(state.loading, action, state),
    teams: teams(state.teams, action, state),
  };
};
